import styled from 'styled-components';

const CartRow = styled.div`
  padding: ${({ theme }) =>
    `0 ${theme.constants.lateralSpace} 0 ${theme.constants.lateralSpace}`};
`;

export default CartRow;
